/*
 * Project: bellcloud
 * File: packages/types/device/lite/protocol_fn_params.ts
 * Author: SWAN
 * Created: 2025-07-08 15:33:54
 *  Description: ClassID / FunctionID에 따른 파라미터 매핑
 */
import { ClassID } from './cmds';
import type { FunctionParameter } from '../fns';
import { params_information } from './fn_information';
import { params_monitoring } from './fn_monitoring';
import { params_configuration } from './fn_configuration';
import { params_cal_bump } from './fn_cal_bump';
import { params_file_transfer } from './fn_file_transfer';
import { params_maintenance } from './fn_maintenance';

const PARAMS_BY_CLASS: Partial<Record<ClassID, Record<number, FunctionParameter[]>>> = {
  [ClassID.INFORMATION]: params_information,
  [ClassID.MONITORING]: params_monitoring,
  [ClassID.CONFIGURATION]: params_configuration,
  [ClassID.CALIBRATION]: params_cal_bump,
  [ClassID.FILE_TRANSFER]: params_file_transfer,
  [ClassID.MAINTENANCE]: params_maintenance,
};

export function getFunctionParameters(classId: ClassID, functionId: number): FunctionParameter[] {
  return PARAMS_BY_CLASS[classId]?.[functionId] ?? [];
}
